import PageContentMobile from './PageContentMobile';
import PageContentDesktop from './PageContentDesktop';
import { isMobile } from 'utils/isMobile';

export default isMobile ? PageContentMobile : PageContentDesktop;
